import { Routes, Route, Navigate } from "react-router-dom";
import Participants from "./Participants/index.js";

const MatchStatus = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="participants" replace />} />
        <Route path="participants" element={<Participants />} />
      </Routes>
    </>
  );
};
export default MatchStatus;
